import * as React from "react"
const SvgComponent = (
  props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    fill="none"
    {...props}
  >
    <path
      fill="#FF7F0A"
      fillRule="evenodd"
      d="M22.263 6.457a.75.75 0 0 0-.01-.926L18.029.25H5.308L1.082 5.531a.75.75 0 0 0-.008.926l10.006 13a.75.75 0 0 0 1.19 0l9.993-13ZM8.668 7h6V5h-6v2Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgComponent
